export const ALL_CATEGORIES = [
  'Standard',
  'Premium',
  'Iets\'ene Tiger',
  'Trash To Treasure',
  'Raw',
  'Nostalgic Marble',
  'Beads',
  'Cowrie shell',
  'Denim',
  'Collaboration',
  'Workshop'
];

export const ENV = process.env.REACT_APP_ENV === 'dev' ? 'dev' : '';
export const APP_VERSION = process.env.REACT_APP_VERSION || '0.1.0';
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const DB_PATH = ENV ? `${ENV}/products` : 'products';
export const LOG_PATH = ENV ? 'dev/logs/public' : 'logs/public';
